module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTabBar),
      expression: "isTabBar"
    }],
    staticClass: "tab-bar-content"
  }, [_c('z-tab-bar', {
    attrs: {
      "list-obj": _vm.tabBarParams.list,
      "active": _vm.tabBarParams.active
    },
    on: {
      "handleClickTabBar": _vm.handleTab
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.params.type == 'news') ? _c('section', {
    staticClass: "module news-list"
  }, [_c('ul', _vm._l((_vm.news.item || []), function(item, index) {
    return _c('li', {
      staticClass: "fx",
      on: {
        "click": function($event) {
          return _vm.handleSelectMaterial(item, index)
        }
      }
    }, [_c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selected == index),
        expression: "selected == index"
      }],
      staticClass: "selected icon-gou fx-align",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleCancelSelected($event)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pic fx-shrink"
    }, [_c('img', {
      attrs: {
        "width": "100",
        "height": "100",
        "src": _vm._f("showWxImages")(item.content.news_item[0].thumb_url)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title fx-fill"
    }, [_c('ol', _vm._l((item.content.news_item || []), function(subItem, subIndex) {
      return _c('li', [_c('a', [_vm._v(_vm._s(subIndex + 1) + "." + _vm._s(subItem.title))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("momentUnixFmt")(item.update_time)) + "\n\t\t\t\t\t")])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.params.type == 'image') ? _c('section', {
    staticClass: "module image-list"
  }, [_c('ul', {
    staticClass: "fx fx-wrap"
  }, _vm._l((_vm.image.item || []), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.handleSelectMaterial(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "width": "200",
        "height": "200",
        "src": _vm._f("showWxImages")(item.url)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-ellipsis"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selected == index),
        expression: "selected == index"
      }],
      staticClass: "selected icon-gou fx-align",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleCancelSelected($event)
        }
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.params.type == 'voice') ? _c('section', {
    staticClass: "module voice-list"
  }, [_c('ul', _vm._l((_vm.voice.item || []), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.handleSelectMaterial(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "item fx fx-y-center b-r-3"
    }, [_c('p', {
      staticClass: "icon-video fx-shrink"
    }), _vm._v(" "), _c('div', {
      staticClass: "fx-fill text"
    }, [_c('p', {
      staticClass: "text-ellipsis"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("momentFmt")(item.update_time)))])]), _vm._v(" "), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selected == index),
        expression: "selected == index"
      }],
      staticClass: "selected icon-gou fx-align",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleCancelSelected($event)
        }
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.params.type == 'video') ? _c('section', {
    staticClass: "module video-list"
  }, [_c('ul', _vm._l((_vm.video.item || []), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.handleSelectMaterial(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "item fx fx-y-center b-r-3"
    }, [_c('p', {
      staticClass: "icon-video fx-shrink"
    }), _vm._v(" "), _c('div', {
      staticClass: "fx-fill text"
    }, [_c('p', {
      staticClass: "text-ellipsis"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("momentFmt")(item.update_time)))])]), _vm._v(" "), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selected == index),
        expression: "selected == index"
      }],
      staticClass: "selected icon-gou fx-align",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleCancelSelected($event)
        }
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount <= 0),
      expression: "totalCount <=0"
    }],
    staticClass: "p-20"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("暂无相关数据")])])]), _vm._v(" "), _c('section', {
    staticClass: "fx oper-page"
  }, [_c('div', {
    staticClass: "fx-fill"
  }, [_c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleLinkWx
    }
  }, [_vm._v("添加素材")])]), _vm._v(" "), _c('z-pages', {
    attrs: {
      "offset": _vm.params.offset,
      "count": _vm.params.count,
      "total-count": _vm.totalCount
    },
    on: {
      "handleOffset": _vm.handleOffset
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5b91cabf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/Material.vue
// module id = 852
// module chunks = 0